<template>
    <div>
        <el-alert title="成绩根据学生报考的专业下的科目数为准，有多少专业就有多少成绩记录导出后填好分数上传" type="info"  show-icon :closable="false"></el-alert>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="年份:" prop="year">
                    <el-date-picker
                            style="width: 200px"
                            size="mini"
                            v-model="searchForm.year"
                            type="year"
                            placeholder="选择年份"
                            format="yyyy"
                            value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="准考证号:" prop="ticketNumber">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.ticketNumber" placeholder="请输入准考证号"></el-input>
                </el-form-item>
                 <el-form-item label="考生姓名:" prop="name">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.name" placeholder="请输入考生姓名"></el-input>
                </el-form-item>
                 <el-form-item label="专业名称:" prop="majorId">
                     <el-select v-model="searchForm.majorId" size="mini" filterable @change="getMajorItemList(searchForm.majorId)" placeholder="请选择专业">
                         <el-option v-for="item in majorList" :key="item.id" :label="item.name" :value="item.id">
                         </el-option>
                     </el-select>
                </el-form-item>
                 <el-form-item label="科目名称:" prop="majorItemId">
                     <el-select v-model="searchForm.majorItemId" size="mini" filterable placeholder="请选择科目">
                         <el-option v-for="item in majorItemList" :key="item.id" :label="item.name" :value="item.id">
                         </el-option>
                     </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentScore-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                </el-form-item>
            </el-form>
         </div>
         <div style="margin-bottom: 10px;float: right;" >
            <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
            <el-button plain size="mini" type="primary" v-display:sysStudentScore-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
            <el-dropdown>
                 <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                     批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                 </el-button>
                 <el-dropdown-menu slot="dropdown">
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentScore-batchDelete icon="el-icon-delete" @click="batchDelete" >批量删除</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentScore-leadingIn icon="el-icon-upload" @click="leadingInsysStudentScore">导入</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentScore-export icon="el-icon-download" @click="exportsysStudentScore">导出</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentScore-exportModule icon="el-icon-download" @click="exportsysStudentScoreModule('upsertForm')">下载模板</el-button></el-dropdown-item>
                 </el-dropdown-menu>
             </el-dropdown>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" height="70vh" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sequence" label="序号" sortable="custom" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="studyCode" label="报名序号" sortable="custom" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="ticketNumber" label="准考证号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="studyColleges" label="报考院校"></el-table-column>
            <el-table-column show-overflow-tooltip prop="majorName" label="专业名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="majorItemName" label="科目名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="score" label="分数" sortable="custom" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="year" label="年份" sortable="custom" ></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><el-button type="text" v-display:sysStudentScore-update @click="showUpdateDialog(scope.row.id)">修改</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysStudentScore-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysStudentScore-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                  <el-form-item label="序号">
                     <el-input size="mini" readonly maxlength="32" show-word-limit  v-model="upsertForm.sequence" placeholder="请输入序号" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="报名序号">
                     <el-input size="mini" readonly maxlength="32" show-word-limit  v-model="upsertForm.studyCode" placeholder="请输入报名序号" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="准考证号">
                     <el-input size="mini" readonly maxlength="32" show-word-limit  v-model="upsertForm.ticketNumber" placeholder="请输入准考证号" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="考生姓名">
                     <el-input size="mini" readonly maxlength="32" show-word-limit  v-model="upsertForm.name" placeholder="请输入考生姓名" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="身份证号">
                     <el-input size="mini" readonly maxlength="32" show-word-limit  v-model="upsertForm.idCard" placeholder="请输入身份证号" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="报考院校" prop="studyColleges">
                     <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studyColleges" placeholder="请输入报考院校" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="专业名称:" prop="majorId">
                      <el-select v-model="upsertForm.majorId" size="mini" filterable @click-native="setMajorName" @change="getMajorItemsList(upsertForm.majorId)" placeholder="请选择专业">
                          <el-option v-for="item in majorsList" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
                <el-form-item label="科目名称:" prop="majorItemId">
                    <el-select v-model="upsertForm.majorItemId" size="mini" @click-native="setMajorItemName" filterable placeholder="请选择科目">
                        <el-option v-for="item in majorItemsList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                  <el-form-item label="分数" prop="score">
                     <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.score" placeholder="请输入分数" auto-complete="off"></el-input>
                 </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysStudentScore-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysStudentScore-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
            <div>
            <el-form class="upsertForm" :inline="true" label-width="100px">
               <el-form-item label="序号" prop="sequence">
                <el-input size="mini" v-model="upsertForm.sequence" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="报名序号" prop="studyCode">
                <el-input size="mini" v-model="upsertForm.studyCode" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="准考证号" prop="ticketNumber">
                <el-input size="mini" v-model="upsertForm.ticketNumber" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="考生姓名" prop="name">
                <el-input size="mini" v-model="upsertForm.name" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="身份证号" prop="idCard">
                <el-input size="mini" v-model="upsertForm.idCard" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="报考院校" prop="studyColleges">
                <el-input size="mini" v-model="upsertForm.studyColleges" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="专业名称" prop="majorName">
                <el-input size="mini" v-model="upsertForm.majorName" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="科目名称" prop="majorItemName">
                <el-input size="mini" v-model="upsertForm.majorItemName" readonly auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="分数" prop="score">
                <el-input size="mini" v-model="upsertForm.score" readonly auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column prop="sequence" label="序号"></el-table-column>
                    <el-table-column prop="studyCode" label="报名序号"></el-table-column>
                    <el-table-column prop="ticketNumber" label="准考证号"></el-table-column>
                    <el-table-column prop="name" label="考生姓名"></el-table-column>
                    <el-table-column prop="idCard" label="身份证号"></el-table-column>
                    <el-table-column prop="studyColleges" label="报考院校"></el-table-column>
                    <el-table-column prop="majorName" label="专业名称"></el-table-column>
                    <el-table-column prop="majorItemName" label="科目名称"></el-table-column>
                    <el-table-column prop="score" label="分数"></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                           style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                           :action="uploadUrl"
                           :headers="headers"
                           multiple
                           :show-file-list="false"
                           :on-success="handlesysStudentScoreSuccess"
                           :before-upload="beforesysStudentScoreUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportsysStudentScoreModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudentScore",
        components: { noData },
        data() {
            return {
                searchForm:{
                      adminId: '',
                      adminName: '',
                      studentId: '',
                      sequence: '',
                      studyCode: '',
                      ticketNumber: '',
                      name: '',
                      idCard: '',
                      studyColleges: '',
                      majorId: '',
                      majorName: '',
                      majorItemId: '',
                      majorItemName: '',
                      score: '',
                      year:'',
                      updateTime: '',
                      createTime: '',
                    pager:{
                        sortField:'majorName',
                        sortOrder:'asc',
                        page:1,
                        pageSize:20,
                        totalCount:0,
                        like:'ticketNumber,name,majorName,majorItemName,createTime'
                    }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    studentId:'',
                    sequence:'',
                    studyCode:'',
                    ticketNumber:'',
                    name:'',
                    idCard:'',
                    studyColleges:'',
                    majorId:'',
                    majorName:'',
                    majorItemId:'',
                    majorItemName:'',
                    score:'',
                    year:'',
                    updateTime:'',
                    createTime:''
                },
                searchRules: {
                          adminId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sequence: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          ticketNumber: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          name: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyColleges: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorItemId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorItemName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          score: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                rules: {
                          adminId: [
                                  { required: true, message: '请输入操作人编', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  { required: true, message: '请输入操作人', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  { required: true, message: '请输入学生编号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sequence: [
                                  { required: true, message: '请输入序号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyCode: [
                                  { required: true, message: '请输入报名序号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          ticketNumber: [
                                  { required: true, message: '请输入准考证号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          name: [
                                  { required: true, message: '请输入考生姓名', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  { required: true, message: '请输入身份证号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyColleges: [
                                  { required: true, message: '请输入报考院校', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorId: [
                                  { required: true, message: '请输入考试科目', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorName: [
                                  { required: true, message: '请输入专业名称', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorItemId: [
                                  { required: true, message: '请输入科目编号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          majorItemName: [
                                  { required: true, message: '请输入科目名称', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          score: [
                                  { required: true, message: '请输入分数', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudentScore/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                majorItemList:[],
                majorList:[],
                majorItemsList:[],
                majorsList:[],
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysStudentScore/update/findSysStudentScoreById/${id}`,
                    method:'GET'
                }).then(res=>{
                    this.getMajorItemsList(res.data.majorId);
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentScore/${this.dialog.title==='增加'?'saveSysStudentScore':'update/updateSysStudentScore'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentScore/deleteSysStudentScore/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudentScore/findSysStudentScoresByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysStudentScore/look/lookSysStudentScoreById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInsysStudentScore() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportsysStudentScore() {
                axios({
                    url: `${home}/sysStudentScore/exportSysStudentScore`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    var date=new Date;
                    var y = date.getFullYear()
                    fileDownload(res, y+"年武汉晴川学院专升本学生成绩.xls");
                });
            },
            exportsysStudentScoreModule() {
                axios({
                    url: `${home}/sysStudentScore/exportSysStudentScoreModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    var date=new Date;
                    var y = date.getFullYear()
                    fileDownload(res, y+"年武汉晴川学院专升本学生成绩模板.xls");
                });

            },
            handlesysStudentScoreSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysStudentScoreUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentScore/batchDeleteSysStudentScore`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            getMajorList(){
                axios({
                    url: `${home}/sysDdList/getMajorList`,
                    method: "GET",
                }).then(res => {
                    this.majorList = res.data;
                    this.majorsList = res.data;
                });
            },
            getMajorItemList(id){
                axios({
                    url: `${home}/sysDdList/getMajorItemList/${id}`,
                    method: "GET",
                }).then(res => {
                    this.majorItemList = res.data;
                });
            },
            getMajorItemsList(id){
                axios({
                    url: `${home}/sysDdList/getMajorItemList/${id}`,
                    method: "GET",
                }).then(res => {
                    this.majorItemsList = res.data;
                });
            },
            setMajorName(e){
                this.upsertForm.majorName = e.target.innerText;
            },
            setMajorItemName(e){
                this.upsertForm.majorItemName = e.target.innerText;
            }

        }
    }
</script>
